module.exports = __webpack_public_path__ + "img/scene2.5cde92ca.webp";